import configureStore from './configureStore';
export const store = configureStore();


// WEBPACK FOOTER //
// ./src/Store.js